import { type MouseEvent, memo, useCallback } from 'react';

import { type Discussion } from '@air/api/types';
import { ReplyIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';

import { useDiscussionPanelContext } from '~/components/AssetModal/shared/context/DiscussionsPanelContext/DiscussionsPanelContext';
import { useAssetModalRightPanel } from '~/components/AssetModalV2/AssetModalRightPanelContextProvider';

export type ReplyButtonProps = {
  discussionId: Discussion['id'];
};

export const ReplyButton = memo(({ discussionId }: ReplyButtonProps) => {
  const { setReplyingDiscussionId } = useDiscussionPanelContext();
  const { showRightPanelTab } = useAssetModalRightPanel();

  const handleReplyClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      showRightPanelTab('comments');
      setReplyingDiscussionId(discussionId);
    },
    [showRightPanelTab, setReplyingDiscussionId, discussionId],
  );

  return (
    <Button
      appearance="ghost"
      color="gray"
      data-testid="DISCUSSION_COMMENT_ADD_REPLY"
      prefix={<ReplyIcon size="xs" />}
      size="small"
      onClick={handleReplyClick}
    >
      Reply
    </Button>
  );
});

ReplyButton.displayName = 'ReplyButton';
